import {
  addAttachmentDigisign,
  addAttachmentDigisignSk,
  addAttachmentSertifikatExternalDigisign,
  addDocumentDigiSign,
  addSertifikatExternal,
  approveDocumentDigiSign,
  checkPDFDigisign,
  getApprovalSK,
  getCompletedDigisign,
  getCompletedDigisignSk,
  getComposerDigisign,
  getDetailCourseDigisign,
  getDetailDigisign,
  getDetailDraftDigisign,
  getDetailSertifikatExternal,
  getDokumenSKPYB,
  getDraftDigisign,
  getInprogressDigisign,
  getListCourseDigisign,
  getNeedSignSK,
  getParafBeforeTTDEDigisign,
  getParafDigisign,
  getPenerimaSertifikatByCourse,
  getPenomoranDigisign,
  getPerizinanEseaCount,
  getPerizinanPKRLCount,
  getReadyDigisign,
  getRejectedDigisign,
  getRejectedPerizinanDigisign,
  getRetryDigisign,
  getSertifikatExternal,
  getSignedDigisign,
  getSubjectList,
  getSummaryCount,
  getSummaryList,
  getTemplateTitikDigisign,
  getTrackDigisign,
  putApprove,
  putDocumentDigiSign,
  putDocumentPerizinanDigiSign,
  putDocumentPkCancel,
  putDocumentPkReturn,
  putDocumentSkReject,
  putDocumentSkReturn,
  putDocumentSkRevision,
  putEvaluasiDigisign,
  putRelease,
  rejectDokumenDigiSign,
  rejectDokumenPerizinanDigiSign,
  getListLaporanDigisign,
  deleteDocumentDigisign,
  addDocumentDigiSignPk,
  getInboxPK,
  getMonitoringListDigisign,
  getMonitoringDashboardDigisign,
  getRejectedDigisignSk,
  getRejectedDigisignPk,
  exportPK,
  getListDokumenLPMUKP,
  getDetailDokumenLPMUKP,
  getDocumentCounter,
  getDigisignCount,
  getDashboardCountDokumen,
  submitDokumenLPMUKP,
  addCSVToJSONDigisign,
  getComposerSMDigisign,
  getInprogressSMDigisign,
  getReadySMDigisign,
  getCompletedSMDigisign,
  putApproveSM,
  exportSK,
  getDokumenSKPYBPPID,
  getDokumenPKPYB,
  getRevisiDigisignSk,
  getSiapMutuCount,
  getNumberDigisign,
  getRevisionDigisign,
  getTemplateReceiversBankom,
} from '@crema/services/apis/digisign';
import { appIntl } from '@crema/utility/helper/Utils';
import {
  ADD_ATTACHMENT_DIGISIGN,
  ADD_DOCUMENT_DIGISIGN,
  DELETE_ATTACHMENT_DIGISIGN,
  DELETE_DETAIL_COURSE_DIGISIGN,
  DELETE_PENOMORAN_PERIZINAN,
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  GET_DASHBOARD_SK,
  GET_DETAIL_COURSE_DIGISIGN,
  GET_DETAIL_DIGISIGN,
  GET_DETAIl_DOKUMEN_LPMUKP,
  GET_DETAIL_SERTIFIKAT_EXTERNAL,
  GET_LIST_APPROVAL_SK,
  GET_LIST_COMPLETED,
  GET_LIST_COMPOSER,
  GET_LIST_COURSE_DIGISIGN,
  GET_LIST_DOKUMEN_LPMUKP,
  GET_LIST_DRAFT,
  GET_LIST_INBOX_PK,
  GET_LIST_INPROGRESS,
  GET_LIST_NEEDSIGN_SK,
  GET_LIST_READY,
  GET_MONITORING_DASHBOARD,
  GET_OPTION_PYB,
  GET_PENERIMA_SERTIF_DIGISIGN,
  GET_PENOMORAN_PERIZINAN,
  GET_PERIZINAN_ESEA_COUNT,
  GET_PERIZINAN_PKRL_COUNT,
  GET_PERIZINAN_PKRL_DASHBOARD,
  GET_REJECTED_DIGISIGN,
  GET_RETRY_DIGISIGN,
  GET_SERTIFIKAT_EXTERNAL,
  GET_SIGNED_DIGISIGN,
  GET_SUBJECT_LIST,
  GET_SUMMARY_COUNT,
  GET_SUMMARY_LIST,
  GET_TEMPLATE_DIGISIGN,
  GET_TRACK_DIGISIGN,
  ONCHANGE_STATE_FILTER,
  ONCHANGE_STATE_FILTER_PM,
  REJECT_DOCUMENT_DIGISIGN,
  RESET_DIGISIGN,
  SHOW_MESSAGE,
  UPDATE_DOCUMENT_DIGISIGN,
  CHANGE_FILTER_PLPMUKP,
  GET_DIGISIGN_COUNT,
  ADD_CSV_TO_JSON_DIGISIGN,
  GET_DASHBOARD_COUNT_DOKUMEN,
  GET_OPTION_PYB_PPID,
  GET_OPTION_PYB_PK,
  GET_REVISI_DIGISIGN,
  GET_SIAPMUTU_COUNT,
  GET_LIST_NUMBER,
  GET_LIST_REVISION,
  RESET_LIST_RECEIVERS_DIGISIGN,
  GET_TEMPLATE_RECEIVERS_BANKOM
} from 'shared/constants/ActionTypes';
import { API } from 'shared/constants/AppEnums';

export const onGetComposerDigisign = (tipe, general = '', page = 0, limit) => {
  const { messages } = appIntl();
  return (dispatch) => {
    let tempLimit = tipe === 'bankom' ? 25 : 10;
    dispatch({ type: FETCH_START });
    getComposerDigisign(tipe, general, page, limit === undefined ? tempLimit : limit)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_LIST_COMPOSER, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetDraftDigisign = (tipe, general = '', page = 0) => {
  const { messages } = appIntl();
  return (dispatch) => {
    let limit = tipe === 'bankom' ? 25 : 10;
    dispatch({ type: FETCH_START });
    getDraftDigisign(tipe, general, page, limit)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_LIST_DRAFT, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetApprovalSK = (tipe, general = '', page = 0) => {
  const { messages } = appIntl();
  return (dispatch) => {
    let limit = tipe === 'bankom' ? 25 : 10;
    dispatch({ type: FETCH_START });
    getApprovalSK(tipe, general, page, limit)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_LIST_APPROVAL_SK, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetInboxPK = (tipe, general = '', page = 0) => {
  const { messages } = appIntl();
  return (dispatch) => {
    let limit = tipe === 'bankom' ? 25 : 10;
    dispatch({ type: FETCH_START });
    getInboxPK(tipe, general, page, limit)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_LIST_INBOX_PK, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetNeedSignSK = (tipe, general = '', page = 0) => {
  const { messages } = appIntl();
  return (dispatch) => {
    let limit = tipe === 'bankom' ? 25 : 10;
    dispatch({ type: FETCH_START });
    getNeedSignSK(tipe, general, page, limit)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_LIST_NEEDSIGN_SK, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetInprogressDigisign = (
  tipe,
  general = '',
  page = 0,
  limit,
) => {
  const { messages } = appIntl();
  return (dispatch) => {
    // let limit = tipe === 'bankom' ? 25 : 10
    dispatch({ type: FETCH_START });
    getInprogressDigisign(tipe, general, page, limit)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_LIST_INPROGRESS, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetReadyDigisign = (tipe, general = '', page = 0) => {
  const { messages } = appIntl();
  return (dispatch) => {
    let limit = tipe === 'bankom' ? 25 : 10;
    dispatch({ type: FETCH_START });
    getReadyDigisign(tipe, general, page, limit)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_LIST_READY, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetCompletedDigisign = (tipe, general = '', page = 0, limit) => {
  const { messages } = appIntl();
  return (dispatch) => {
    // let limit = tipe === 'bankom' ? 25 : 10
    dispatch({ type: FETCH_START });
    getCompletedDigisign(tipe, general, page, limit)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_LIST_COMPLETED, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetNumberDigisign = (tipe, general = '', page = 0, limit) => {
  const { messages } = appIntl();
  return (dispatch) => {
    let tempLimit = tipe === 'bankom' ? 25 : 10;
    dispatch({ type: FETCH_START });
    getNumberDigisign(tipe, general, page, limit === undefined ? tempLimit : limit)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_LIST_NUMBER, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetRevisionDigisign = (tipe, general = '', page = 0, limit) => {
  const { messages } = appIntl();
  return (dispatch) => {
    let tempLimit = tipe === 'bankom' ? 25 : 10;
    dispatch({ type: FETCH_START });
    getRevisionDigisign(tipe, general, page, limit === undefined ? tempLimit : limit)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_LIST_REVISION, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetCompletedDigisignSk = (
  tipe,
  general = '',
  page = 0,
  limit,
) => {
  const { messages } = appIntl();
  return (dispatch) => {
    // let limit = tipe === 'bankom' ? 25 : 10
    dispatch({ type: FETCH_START });
    getCompletedDigisignSk(tipe, general, page, limit)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_LIST_COMPLETED, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetRejectedDigisign = (general = '', page = 0) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getRejectedDigisign(general, page)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_REJECTED_DIGISIGN, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetRejectedDigisignSk = (tipe = '', general = '', page = 0) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getRejectedDigisignSk(tipe, general, page)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_REJECTED_DIGISIGN, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetRevisiDigisignSk = (tipe = '', general = '', page = 0) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getRevisiDigisignSk(tipe, general, page)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_REVISI_DIGISIGN, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetRejectedDigisignPk = (general = '', page = 0) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getRejectedDigisignPk(general, page)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_REJECTED_DIGISIGN, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetRejectedPerizinanDigisign = (general = '', page = 0) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getRejectedPerizinanDigisign(general, page)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_REJECTED_DIGISIGN, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetSignedDigisign = (tipe, general = '', page = 0) => {
  const { messages } = appIntl();
  return (dispatch) => {
    let limit = tipe === 'bankom' ? 25 : 10;
    dispatch({ type: FETCH_START });
    getSignedDigisign(tipe, general, page, limit)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_SIGNED_DIGISIGN, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetRetryDigisign = (tipe, general = '', page = 0) => {
  const { messages } = appIntl();
  return (dispatch) => {
    let limit = tipe === 'bankom' ? 25 : 10;
    dispatch({ type: FETCH_START });
    getRetryDigisign(tipe, general, page, limit)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_RETRY_DIGISIGN, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetDetailDigisign = (id, isMonitoring = false) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    dispatch({ type: GET_DETAIL_DIGISIGN, payload: null });
    getDetailDigisign(id, isMonitoring)
      .then((data) => {
        if (data.success) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_DETAIL_DIGISIGN, payload: data.result });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetDetailDraftDigisign = (id) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getDetailDraftDigisign(id)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_DETAIL_DIGISIGN, payload: data.result });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onResetDetailDigisign = () => {
  return (dispatch) => {
    dispatch({ type: GET_DETAIL_DIGISIGN, payload: null })
  }
}

export const onAddDocumentDigisign = (
  dataDocument,
  tipe,
  handleNavigate = undefined,
) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    addDocumentDigiSign(dataDocument, tipe)
      .then((data) => {
        if (data.success) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: ADD_DOCUMENT_DIGISIGN, payload: data.result });
          if (dataDocument.action === 'submit') {
            if (tipe === 'bankom') {
              dispatch({
                type: SHOW_MESSAGE,
                payload: 'Data Sertifikat Berhasil Ditambahkan',
              });
            } else if (tipe === 'dokumen_pkrl') {
              dispatch({
                type: SHOW_MESSAGE,
                payload: 'Dokumen Perizinan Berhasil Dikirim',
              });
            } else {
              dispatch({
                type: SHOW_MESSAGE,
                payload: 'Data Dokumen Berhasil Ditambahkan',
              });
            }
          } else {
            if (tipe === 'bankom') {
              dispatch({
                type: SHOW_MESSAGE,
                payload: 'Data Sertifikat Berhasil Disimpan di draft',
              });
            } else {
              dispatch({
                type: SHOW_MESSAGE,
                payload: 'Data Dokumen Berhasil Disimpan di draft',
              });
            }
          }

          if (handleNavigate) {
            setTimeout(() => {
              handleNavigate();
            }, 1000);
          }
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onAddDocumentDigisignPk = (
  dataDocument,
  setAttchmentId = undefined,
) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    addDocumentDigiSignPk(dataDocument)
      .then((data) => {
        if (data.success) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: SHOW_MESSAGE, payload: 'File Berhasil di Upload!' });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onApproveDocumentDigisign = (dataDocument, onSucces = undefined, onError = undefined) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    approveDocumentDigiSign(dataDocument)
      .then((data) => {
        if (data.success) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: SHOW_MESSAGE,
            payload: 'Dokumen Berhasil Disetujui!',
          });

          setTimeout(() => {
            if (onSucces) {
              onSucces()
            }
          }, 2000)
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: data?.result?.message || messages['message.somethingWentWrong'],
          });
          if (onError) {
            onError()
          }
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
        if (onError) {
          onError()
        }
      });
  };
};

export const onPutDocumentDigisign = (
  dataDocument,
  id,
  tipe,
  handleNavigate = undefined,
) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    putDocumentDigiSign(dataDocument, id)
      .then((data) => {
        if (data.success) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: UPDATE_DOCUMENT_DIGISIGN, payload: data.result });
          if (dataDocument.action === 'submit') {
            if (tipe === 'bankom') {
              dispatch({
                type: SHOW_MESSAGE,
                payload: 'Data Sertifikat Berhasil Diubah',
              });
            } else {
              dispatch({
                type: SHOW_MESSAGE,
                payload: 'Data Dokumen Berhasil Diubah',
              });
            }
          } else {
            if (tipe === 'bankom') {
              dispatch({
                type: SHOW_MESSAGE,
                payload: 'Data Sertifikat Berhasil Diubah di draft',
              });
            } else {
              dispatch({
                type: SHOW_MESSAGE,
                payload: 'Data Dokumen Berhasil Diubah di draft',
              });
            }
          }

          if (handleNavigate) {
            setTimeout(() => {
              handleNavigate();
            }, 1000);
          }
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onPutDocumentDigisignPk = (dataDocument, id, setSignState) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    putDocumentDigiSignPk(dataDocument, id)
      .then((data) => {
        if (data.success) {
          dispatch({ type: FETCH_SUCCESS });
          setSignState(true);
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onPutDocumentPkReturn = (dataDocument, onSucces = undefined, onError = undefined) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    putDocumentPkReturn(dataDocument)
      .then((data) => {
        if (data.success) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: UPDATE_DOCUMENT_DIGISIGN, payload: data.result });
          dispatch({
            type: SHOW_MESSAGE,
            payload: 'Dokumen Berhasil Direturn!',
          });

          setTimeout(() => {
            if (onSucces) {
              onSucces()
            }
          }, 2000)
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: data?.result?.message || messages['message.somethingWentWrong'],
          });
          if (onError) {
            onError()
          }
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
        if (onError) {
          onError()
        }
      });
  };
};

export const onPutDocumentPkCancel = (dataDocument, onSucces = undefined, onError = undefined) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    putDocumentPkCancel(dataDocument)
      .then((data) => {
        if (data.success) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: UPDATE_DOCUMENT_DIGISIGN, payload: data.result });
          dispatch({
            type: SHOW_MESSAGE,
            payload: 'Data Dokumen Berhasil Di Batalkan',
          });

          setTimeout(() => {
            if (onSucces) {
              onSucces()
            }
          }, 2000)
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: data?.result?.message || messages['message.somethingWentWrong'],
          });
          if (onError) {
            onError()
          }
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
        if (onError) {
          onError()
        }
      });
  };
};

export const onPutDocumentSkReturn = (dataDocument) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    putDocumentSkReturn(dataDocument)
      .then((data) => {
        if (data.success) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: UPDATE_DOCUMENT_DIGISIGN, payload: data.result });
          dispatch({
            type: SHOW_MESSAGE,
            payload: 'Data Dokumen Berhasil Return',
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onPutDocumentSkRevision = (dataDocument) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    putDocumentSkRevision(dataDocument)
      .then((data) => {
        if (data.success) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: UPDATE_DOCUMENT_DIGISIGN, payload: data.result });
          dispatch({
            type: SHOW_MESSAGE,
            payload: 'Data Dokumen Berhasil Di Revisi',
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};


export const onGetDocumentCounter = (type, isMonitoring = false) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getDocumentCounter(type)
      .then((data) => {
        if (data.success) {
          dispatch({ type: FETCH_SUCCESS })
          let temp = undefined
          if (type === 'dokumen_sk') {
            temp = data.result.sk_count
          } else if (type === 'dokumen_ppid') {
            temp = data.result.ppid_count
          } else if (type === 'dokumen_dirjend') {
            temp = data.result.dirjend_count
          } else {
            temp = isMonitoring
              ? data.result.pk_count_monitoring
              : data.result.pk_count
          }
          dispatch({ type: GET_DASHBOARD_SK, payload: temp })
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onPutDocumentSkReject = (dataDocument) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    putDocumentSkReject(dataDocument)
      .then((data) => {
        if (data.success) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: UPDATE_DOCUMENT_DIGISIGN, payload: data.result });
          dispatch({
            type: SHOW_MESSAGE,
            payload: 'Data Dokumen Berhasil Di Batalkan',
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onAddAttachmentDigisign = (
  type,
  file,
  handleCountUploadDokumen = undefined,
) => {
  const { messages } = appIntl();
  return (dispatch) => {
    if (type === 'onDrop') {
      dispatch({ type: FETCH_START });
      addAttachmentDigisign(file)
        .then((data) => {
          if (data.success) {
            dispatch({ type: FETCH_SUCCESS });
            dispatch({ type: ADD_ATTACHMENT_DIGISIGN, payload: data.result });
            dispatch({
              type: SHOW_MESSAGE,
              payload: 'Lampiran Berhasil Ditambahkan',
            });
            if (handleCountUploadDokumen) {
              handleCountUploadDokumen(data.result.id);
            }
          } else {
            if (data.result.file[0]) {
              dispatch({
                type: FETCH_ERROR,
                payload: data.result.file[0],
              });
            } else {
              dispatch({
                type: FETCH_ERROR,
                payload: messages['message.somethingWentWrong'],
              });
            }
          }
        })
        .catch((error) => {
          dispatch({ type: FETCH_ERROR, payload: error });
        });
    } else {
      dispatch({ type: ADD_ATTACHMENT_DIGISIGN, payload: file });
    }
  };
};

export const onAddAttachmentDigisignSK = (
  type,
  file,
  handleCountUploadDokumen = undefined,
) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    addAttachmentDigisignSk(type, file)
      .then((data) => {
        if (data.success) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: ADD_ATTACHMENT_DIGISIGN, payload: data.result });
          dispatch({
            type: SHOW_MESSAGE,
            payload: 'Lampiran Berhasil Ditambahkan',
          });
          if (handleCountUploadDokumen) {
            handleCountUploadDokumen();
          }
        } else {
          if (data.result.file[0]) {
            dispatch({
              type: FETCH_ERROR,
              payload: data.result.file[0],
            });
          } else {
            dispatch({
              type: FETCH_ERROR,
              payload: messages['message.somethingWentWrong'],
            });
          }
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error });
      });
  };
};

export const onReleaseDigiSign = (payload, setRefresh, type, id) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    putRelease(payload, type, id)
      .then((data) => {
        if (data.success) {
          // setRefresh(true)
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: SHOW_MESSAGE,
            payload: 'Surat Keputusan berhasil dirilis',
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: data.result.message,
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onUpdateSignDigisign = (payload, refreshData = undefined, type, errorBypass = undefined) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    putApprove(payload, type)
      .then((data) => {
        if (data.success) {
          dispatch({ type: FETCH_SUCCESS })
          dispatch({ type: SHOW_MESSAGE, payload: 'Dokumen berhasil ditandatangani' })

          setTimeout(() => {
            if (refreshData) {
              refreshData()
            }
          }, 1000)
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: data.result.message
          });
          if (errorBypass) {
            errorBypass()
          }
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
        if (errorBypass) {
          errorBypass()
        }
      })
  };
}

export const onDeleteAttachmentDigisign = (data = []) => {
  return (dispatch) => {
    dispatch({ type: DELETE_ATTACHMENT_DIGISIGN, payload: data });
  };
};

export const onChangeFilter = (state) => {
  return (dispatch) => {
    localStorage.removeItem('page-bankom');
    dispatch({ type: ONCHANGE_STATE_FILTER, payload: state });
  };
};

export const onChangeFilterLPMUKP = (state) => {
  return (dispatch) => {
    localStorage.removeItem('page-bankom');
    dispatch({ type: CHANGE_FILTER_PLPMUKP, payload: state });
  };
};

export const onResetDigisign = () => {
  return (dispatch) => {
    dispatch({ type: RESET_DIGISIGN });
  };
};

export const onGetListCourse = (limit) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getListCourseDigisign(limit)
      .then((res) => {
        if (res) {
          const dataCourse = [];
          res.results.map((item) => {
            dataCourse.push({
              label: item.displayname,
              id: item.id_course,
              jumlah_peserta: item.jumlah_peserta,
              timecreated: item.timecreated,
            });
          });
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_LIST_COURSE_DIGISIGN, payload: dataCourse });
        } else {
          dispatch({ type: FETCH_ERROR, payload: res });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetDetailCourse = (id) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getDetailCourseDigisign(id)
      .then((res) => {
        if (res) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_DETAIL_COURSE_DIGISIGN, payload: res.result });
        } else {
          dispatch({ type: FETCH_ERROR, payload: res });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onDeleteDetailCourse = (id) => {
  return (dispatch) => {
    dispatch({ type: DELETE_DETAIL_COURSE_DIGISIGN });
  };
};

export const onGetSummaryCount = () => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getSummaryCount()
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_SUMMARY_COUNT, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetSummaryList = (
  page,
  jenisSertifikat = '',
  pelatihan = '',
  judulPelatihan = '',
) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getSummaryList(page, jenisSertifikat, pelatihan, judulPelatihan)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_SUMMARY_LIST, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetSubjectList = (pelatihan = '') => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getSubjectList(pelatihan)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_SUBJECT_LIST, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onRejectDokumenDigisign = (data) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    rejectDokumenDigiSign(data)
      .then((data) => {
        if (data.success) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: REJECT_DOCUMENT_DIGISIGN });
          dispatch({ type: SHOW_MESSAGE, payload: 'Dokumen Berhasil Ditolak' });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetTemplateTitikDigisign = () => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getTemplateTitikDigisign()
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_TEMPLATE_DIGISIGN, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onCheckPDFDigisign = (data) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    checkPDFDigisign(data)
      .then((data) => {
        if (data.success) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: ADD_ATTACHMENT_DIGISIGN, payload: data.result });
          dispatch({ type: SHOW_MESSAGE, payload: 'Check PDF Berhasil' });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: 'Ukuran File Lampiran Terlalu Besar ' + error,
        });
      });
  };
};

export const onGetPenerimaSertifikat = (value = '', type = '') => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    if (type === 'reset') {
      dispatch({ type: GET_PENERIMA_SERTIF_DIGISIGN, payload: [] });
      dispatch({ type: FETCH_SUCCESS });
    } else if (type === 'e-learning') {
      getPenerimaSertifikatByCourse(value)
        .then((data) => {
          if (data.success) {
            let newData = [];
            data.result?.map((item) => {
              let id = item.userdata.split('/')[1];
              let nama = item.userdata.split('/')[0];
              newData.push({
                id: id === '-' ? nama : id,
                label: item.userdata,
              });
            });
            dispatch({ type: GET_PENERIMA_SERTIF_DIGISIGN, payload: newData });
            dispatch({ type: FETCH_SUCCESS });
          } else {
            dispatch({ type: FETCH_ERROR, payload: data });
          }
        })
        .catch((error) => {
          dispatch({ type: FETCH_ERROR, payload: error });
          console.log('error', error);
        });
    } else {
      fetch(
        API.GET_FILTER_PEGAWAI_URL.replace('$filter', value),
        API.requestOptionsGET(),
      )
        .then((res) => res.json())
        .then((result) => {
          if (result.status) {
            let newData = [];
            result?.results?.map((item) => {
              newData.push({
                id: item.nip,
                label: `${item.nama}/${item.nip}`,
              });
            });
            dispatch({ type: GET_PENERIMA_SERTIF_DIGISIGN, payload: newData });
            dispatch({ type: FETCH_SUCCESS });
          } else {
            dispatch({ type: FETCH_ERROR, payload: result });
          }
        })
        .catch((err) => {
          dispatch({ type: FETCH_ERROR, payload: err });
          console.log('error', err);
        });
    }
  };
};

export const onPutEvaluasiDigisign = (payload, id, handleClose) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    putEvaluasiDigisign(payload, id)
      .then((data) => {
        if (data.success) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: SHOW_MESSAGE,
            payload: 'Data Evaluasi Berhasil Ditambahkan',
          });
          setTimeout(() => {
            handleClose();
          }, 2000);
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: data,
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetSertifikatExternal = (page = 1, limit = 10, type) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getSertifikatExternal(page, limit, type)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_SERTIFIKAT_EXTERNAL, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetDetailSertifikatExternal = (id) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getDetailSertifikatExternal(id)
      .then((data) => {
        if (data.success) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_DETAIL_SERTIFIKAT_EXTERNAL,
            payload: data.result,
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onAddSertifikatExternal = (
  payload,
  navigate = () => { },
  resetState = () => { },
) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    addSertifikatExternal(payload)
      .then((data) => {
        if (data.success) {
          resetState();
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: SHOW_MESSAGE, payload: 'Data berhasil ditambah' });
          navigate('/apps/sertifikat-eksternal');
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onAddAttachmentSertifikatExternalDigisign = (file) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    addAttachmentSertifikatExternalDigisign(file)
      .then((data) => {
        if (data.success) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: ADD_ATTACHMENT_DIGISIGN, payload: data.result });
          dispatch({
            type: SHOW_MESSAGE,
            payload: 'Lampiran Berhasil Ditambahkan',
          });
        } else {
          if (data.result.file[0]) {
            dispatch({
              type: FETCH_ERROR,
              payload: data.result.file[0],
            });
          } else {
            dispatch({
              type: FETCH_ERROR,
              payload: messages['message.somethingWentWrong'],
            });
          }
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: 'Ukuran File Lampiran Terlalu Besar ' + error,
        });
      });
  };
};

export const onGetDokumenSKPYB = () => {
  const { messages } = appIntl();

  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getDokumenSKPYB()
      .then((data) => {
        if (data.success) {
          dispatch({ type: FETCH_SUCCESS });

          dispatch({ type: GET_OPTION_PYB, payload: data.data });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};


export const onGetDokumenSKPYBPPID = () => {
  const { messages } = appIntl();

  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getDokumenSKPYBPPID()
      .then((data) => {
        if (data.success) {
          dispatch({ type: FETCH_SUCCESS });

          dispatch({ type: GET_OPTION_PYB_PPID, payload: data.data });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetDokumenPKPYB = () => {
  const { messages } = appIntl();

  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getDokumenPKPYB()
      .then((data) => {
        if (data.success) {
          dispatch({ type: FETCH_SUCCESS });

          dispatch({ type: GET_OPTION_PYB_PK, payload: data.data });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetPerizinanEseaCount = () => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getPerizinanEseaCount()
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_PERIZINAN_ESEA_COUNT, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetParafDigisign = (payload, handleRefreshData) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getParafDigisign(payload)
      .then((data) => {
        if (data.success) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: SHOW_MESSAGE, payload: 'Dokumen Berhasil Diparaf' });
          if (handleRefreshData) {
            setTimeout(() => {
              handleRefreshData();
            }, 1000);
          }
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetPenomoranDigisign = (jenis_dokumen = '', tanggal = '') => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getPenomoranDigisign(jenis_dokumen, tanggal)
      .then((data) => {
        if (data.success) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: SHOW_MESSAGE,
            payload: 'Berhasil Mengambil Nomor Perizinan',
          });
          dispatch({
            type: GET_PENOMORAN_PERIZINAN,
            payload: data?.result?.nomor,
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onDeletePenomoranDigisign = () => {
  return (dispatch) => {
    dispatch({ type: DELETE_PENOMORAN_PERIZINAN });
  };
};

export const onRejectDokumenPerizinanDigisign = (data, handleRefreshData) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    rejectDokumenPerizinanDigiSign(data)
      .then((data) => {
        if (data.success) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: SHOW_MESSAGE,
            payload: 'Dokumen Berhasil Dikembalikan',
          });
          if (handleRefreshData) {
            setTimeout(() => {
              handleRefreshData();
            }, 3000);
          }
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onPutDocumentPerizinanDigisign = (
  dataDocument,
  id,
  handleNavigate = undefined,
) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    putDocumentPerizinanDigiSign(dataDocument, id)
      .then((data) => {
        if (data.success) {
          dispatch({ type: FETCH_SUCCESS });
          if (dataDocument.action === 'ttde') {
            dispatch({
              type: SHOW_MESSAGE,
              payload: 'Dokumen Perizinan Berhasil Disimpan',
            });
          } else {
            dispatch({
              type: SHOW_MESSAGE,
              payload: 'Dokumen Perizinan Berhasil Dikirim',
            });
          }
          if (handleNavigate) {
            setTimeout(() => {
              handleNavigate();
            }, 3000);
          }
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetTrackDigisign = (general = '', page = 0) => {
  const { messages } = appIntl();
  return (dispatch) => {
    let limit = 10;
    dispatch({ type: FETCH_START });
    getTrackDigisign(general, page, limit)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_TRACK_DIGISIGN, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetPerizinanPKRLCount = (type) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getPerizinanPKRLCount(type)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          if (type === 'dashboard') {
            dispatch({ type: GET_PERIZINAN_PKRL_COUNT, payload: data.result });
          } else if (type === 'laporan') {
            dispatch({
              type: GET_PERIZINAN_PKRL_DASHBOARD,
              payload: data.result,
            });
          }
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetParafBeforeTTDEDigisign = (payload, handleRefreshData) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getParafBeforeTTDEDigisign(payload)
      .then((data) => {
        if (data.success) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: SHOW_MESSAGE, payload: 'Dokumen Berhasil Diparaf' });
          if (handleRefreshData) {
            setTimeout(() => {
              handleRefreshData();
            }, 1000);
          }
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetListLaporanDigisign = (
  general = '',
  page = 0,
  direktorat = '',
  kategori = '',
) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getListLaporanDigisign(general, page, direktorat, kategori)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_LIST_COMPOSER, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onResetListLaporanDigisign = () => {
  return (dispatch) => {
    dispatch({ type: GET_LIST_COMPOSER, payload: null });
  };
};

export const onDeleteDocumentDigisign = (handleRefreshData, id) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    deleteDocumentDigisign(id)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: SHOW_MESSAGE, payload: 'Dokumen Berhasil Dihapus' });

          if (handleRefreshData) {
            setTimeout(() => {
              handleRefreshData();
            }, 3000);
          }
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: 'Dokumen Gagal Dihapus',
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetMonitoringListDigisign = (
  tipe,
  general = '',
  page = 0,
  limit = 10,
  status = '',
) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getMonitoringListDigisign(tipe, general, page, limit, status)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_LIST_COMPOSER, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetMonitoringDashboardDigisign = () => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getMonitoringDashboardDigisign()
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_MONITORING_DASHBOARD, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onExportPK = (status, isMonitoring = false) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    exportPK(status, isMonitoring)
      .then((data) => {
        if (data.success) {
          dispatch({ type: FETCH_SUCCESS });
          const a = document.createElement('a');
          a.href = data.result.file;
          a.download =
            'Dokumen_PK_' + (isMonitoring ? 'monitoring_' : '') + (status || 'all') + '.xlsx';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: 'Gagal Export Data ' });
      });
  };
};

export const onExportSK = (status) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    exportSK(status)
      .then((data) => {
        if (data.success) {
          dispatch({ type: FETCH_SUCCESS });
          const a = document.createElement('a');
          a.href = data.result.file;
          a.download = 'Dokumen_SK_' + status + '.xlsx';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: 'Gagal Export Data ' });
      });
  };
};

export const onGetListDokumenLPMUKP = (state = 'inprogress', page = 0, search = '') => {
  return (dispatch) => {
    dispatch({ type: FETCH_START })
    getListDokumenLPMUKP(state, page, search)
      .then((res) => {
        if (res) {
          dispatch({ type: FETCH_SUCCESS })
          dispatch({ type: GET_LIST_DOKUMEN_LPMUKP, payload: res })
        } else {
          console.error(res)
          dispatch({ type: FETCH_ERROR, payload: 'Gagal Mengambil List Dokumen' })
        }
      })
      .catch((error) => {
        console.error(error)
        dispatch({ type: FETCH_ERROR, payload: 'Terjadi Kesalahan!' })
      })
  }
}

export const onGetDetailDokumenLPMUKP = (id) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START })
    getDetailDokumenLPMUKP(id)
      .then((res) => {
        if (res.success) {
          dispatch({ type: FETCH_SUCCESS })
          dispatch({ type: GET_DETAIl_DOKUMEN_LPMUKP, payload: res.result })
        } else {
          console.error(res)
          dispatch({ type: FETCH_ERROR, payload: 'Gagal Mengambil Data Detail' })
        }
      })
      .catch((error) => {
        console.error(error)
        dispatch({ type: FETCH_ERROR, payload: 'Terjadi Kesalahan!' })
      })
  }
}

export const onSubmitDokumenLPMUKP = (id, state, payload, navigateBack = null) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START })
    submitDokumenLPMUKP(id, state, payload)
      .then((res) => {
        if (res.success) {
          dispatch({ type: FETCH_SUCCESS })
          dispatch({ type: SHOW_MESSAGE, payload: 'Berhasil Submit Dokumen' })
          if (navigateBack) {
            setTimeout(() => {
              navigateBack()
            }, 1000)
          }
        } else {
          console.error(res)
          dispatch({ type: FETCH_ERROR, payload: 'Gagal Submit Dokumen' })
        }
      })
      .catch((error) => {
        console.error(error)
        dispatch({ type: FETCH_ERROR, payload: 'Terjadi Kesalahan!' })
      })
  }
}

export const onGetDashboardCountDokumen = (filterBy, param) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START })
    getDashboardCountDokumen(filterBy, param)
      .then(res => {
        if (res.success) {
          dispatch({ type: FETCH_SUCCESS })
          dispatch({ type: GET_DASHBOARD_COUNT_DOKUMEN, payload: res })
        } else {
          console.error(res)
          dispatch({ type: FETCH_ERROR, payload: 'Gagal Mengambil Data Dashboard' })
        }
      })
      .catch(error => {
        console.error(error)
        dispatch({ type: FETCH_ERROR, payload: 'Terjadi Kesalahan!' })
      })
  }
}

export const onGetDigisignCount = (type) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getDigisignCount(type)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_DIGISIGN_COUNT, payload: data.result[`${type}_count`] });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

//SERTIFIKAT SM
export const onAddCSVToJSONDigisign = (
  type,
  file,
) => {
  const { messages } = appIntl();
  return (dispatch) => {
    if (type === 'onDrop') {
      dispatch({ type: FETCH_START });
      dispatch({ type: RESET_LIST_RECEIVERS_DIGISIGN });
      addCSVToJSONDigisign(file)
        .then((data) => {
          if (data.success) {
            dispatch({ type: FETCH_SUCCESS });
            dispatch({ type: ADD_CSV_TO_JSON_DIGISIGN, payload: data.result });
            dispatch({
              type: SHOW_MESSAGE,
              payload: 'List Penerima Berhasil Di Convert',
            });
          } else {
            dispatch({
              type: FETCH_ERROR,
              payload: messages['message.somethingWentWrong'],
            });
          }
        })
        .catch((error) => {
          dispatch({ type: FETCH_ERROR, payload: error });
        });
    } else {
      dispatch({ type: ADD_CSV_TO_JSON_DIGISIGN, payload: file });
    }
  };
};

export const onResetListReceiversDigisign = () => {
  return (dispatch) => {
    dispatch({ type: RESET_LIST_RECEIVERS_DIGISIGN })
  };
};

export const onGetComposerSMDigisign = (general = '', page = 0, limit = 25) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getComposerSMDigisign(general, page, limit)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_LIST_COMPOSER, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetInprogressSMDigisign = (
  general = '',
  page = 0,
  limit = 25,
) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getInprogressSMDigisign(general, page, limit)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_LIST_INPROGRESS, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetReadySMDigisign = (general = '', page = 0, limit = 25) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getReadySMDigisign(general, page, limit)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_LIST_READY, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetCompletedSMDigisign = (general = '', page = 0, limit = 25) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getCompletedSMDigisign(general, page, limit)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_LIST_COMPLETED, payload: data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onUpdateSignSMDigisign = (payload, refreshData = undefined) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    putApproveSM(payload)
      .then((data) => {
        if (data.success) {
          setTimeout(() => {
            dispatch({ type: FETCH_SUCCESS })
            dispatch({ type: SHOW_MESSAGE, payload: 'Sertifikat berhasil ditandatangani' })
            if (refreshData) {
              setTimeout(() => {
                refreshData()
                dispatch(onChangeFilter('completed'))
              }, 2000)
            }
          }, 8000)
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: data.result.message
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      })
  };
}

export const onGetSiapMutuCount = (isMonitoring = false) => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getSiapMutuCount(isMonitoring)
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_SIAPMUTU_COUNT, payload: data.result });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetTemplateReceiversBankom = () => {
  const { messages } = appIntl();
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    getTemplateReceiversBankom()
      .then((data) => {
        if (data) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_TEMPLATE_RECEIVERS_BANKOM, payload: data.results });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};